module.exports = __webpack_public_path__ + "static/img/pt.dc1cdc34.png";